import { Menu, MenuButton, MenuItems } from '@headlessui/react';

import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import { twMerge } from 'tailwind-merge';
import React from 'react';
import SelectAssigneeAvatar from 'flow/components/tickets/Assignee/SelectAssigneeAvatar';
import { ExtensionKey } from 'flow/types/EntityKeys';

interface Option {
    key: ExtensionKey | 'unassigned';
    label: string;
    iconKey?: IconKey;
}

interface Props {
    options: Option[];
    title: string | React.ReactNode;
    onItemSelected: (key: ExtensionKey | 'unassigned') => void;
    disabled?: boolean;
}

const SelectAssignee = ({
    title,
    options,
    onItemSelected,
    disabled = false,
}: Props) => {
    return (
        <Menu as="div" className="relative text-left">
            <MenuButton
                disabled={disabled}
                className={twMerge(
                    'inline-flex w-full items-center justify-between rounded-sm bg-gray-200 px-3 py-2 text-sm',
                    disabled
                        ? 'text-gray-300'
                        : 'hover:darken-10 text-gray-800 hover:rounded-sm',
                )}
            >
                {title}
                <Icon iconKey="arrow_down" />
            </MenuButton>
            <MenuItems
                className={
                    'scrollbar shadow-base scrollbar-gutter-stable absolute end-0 z-20 mt-2 max-h-72 w-full origin-top-right rounded-md bg-white py-2 ps-2 outline-gray-100 focus:outline dark:bg-gray-300'
                }
            >
                {options.map((option) => (
                    <MenuItem
                        key={`mi-${option.key}`}
                        onClick={() => onItemSelected(option.key)}
                        disabled={disabled}
                        className="flex items-center gap-2 p-2"
                    >
                        <div className="me-3 flex">
                            <SelectAssigneeAvatar assigneeKey={option.key} />
                        </div>

                        {option.iconKey ? (
                            <Icon iconKey={option.iconKey} className="me-2" />
                        ) : null}
                        <span>{option.label}</span>
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    );
};

export default SelectAssignee;
